export default function guest({ next, store, nextMiddleware }) {
  if (store.state.authState) {
    return next({ name: 'projects'})
  }
  return nextMiddleware()
}